import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import { SluitButton } from "../buttons/SluitButton.jsx";
import { UserProfile } from "./userProfile.jsx";

export const UserModal = ({
  visible,
  onClose,
  pilot,
  currentUser,
  newNotities,
  link,
  onPrev,
  onNext,
}) => {
  if (!pilot) return null;

  return (
    <Modal
      width={"100%"}
      title={pilot.name}
      open={visible}
      onCancel={onClose}
      destroyOnClose
      footer={[
        onPrev && (
          <Button key="prev" icon={<LeftOutlined />} onClick={onPrev}>
            {$t("Vorige")}
          </Button>
        ),
        onNext && (
          <Button key="next" icon={<RightOutlined />} onClick={onNext}>
            {$t("Volgende")}
          </Button>
        ),
        <SluitButton key="sluit" onClick={onClose} />,
      ].filter(Boolean)}
    >
      <UserProfile
        link={link}
        currentUser={currentUser}
        pilot={pilot}
        newNotities={newNotities}
      />
    </Modal>
  );
};
